module.exports = __webpack_public_path__ + "static/media/ni.1b322089.svg";